import styled from 'styled-components';
import { BasicFilterSelect } from 'ui/selects';
import { ModalBody } from 'ui/modal';
import { WebLink2, spacing, colors, Body2, fontSizes } from 'ui/theme';
import { StyledWrapper, StyledInput } from 'ui/inputs/InputStyles';
import { Card } from 'ui/card';
import { OpenNewWindow16 } from 'ui/icons';
import { Avatar } from 'ui/avatar';
import { InfoBanner } from 'ui/banner';
import { SecondaryButton } from 'ui/button';

export const ContactCardFormWrapper = styled.div`
  margin-left: ${spacing.plusHalf};
  flex-grow: 1;
  overflow: visable;

  ${StyledWrapper} {
    padding: 0;
  }

  ${StyledInput} {
    border: none !important;
  }
`;

export const ContactCardImageHelpTextWrapper = styled.span`
  display: flex;
  align-items: center;
`;

export const StyledWebLink = styled(WebLink2)`
  display: flex;
  align-items: center;
  padding-right: ${spacing.base};
`;

export const StyledOpenNewWindow16 = styled(OpenNewWindow16)`
  min-width: ${spacing.base};
`;

export const StyledBasicFilterSelect = styled(BasicFilterSelect)`
  width: 100%;
  [data-test='input-wrapper'] {
    border: ${spacing.single} solid rgba(34, 36, 38, 0.15);
  }
  [data-test='input-prefix'] {
    padding-left: ${spacing.threeEights};
  }
  #contact-cards-sender-select-input-filter {
    border: none;
  }
`;

export const ContactCardHeaderCard = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.base} ${spacing.double};
  margin-bottom: ${spacing.double};
  border-radius: 12px;
  background-color: ${colors.backgroundSecondary};
  filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.06)) drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.06))
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.08));
`;

export const StyledModalBody = styled(ModalBody)`
  background-color: ${colors.backgroundPrimary};
  display: flex;
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  display: flex;
  gap: ${spacing.half};
`;

export const ContactCardListEntryWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  min-height: ${spacing.x4};
  padding-left: ${spacing.base};

  ${Body2} {
    margin: 0 ${spacing.base} 0;
  }

  &.selected {
    background: ${colors.purple10};
    border-radius: 4px;

    ${Body2} {
      color: ${colors.textLink};
    }
  }

  &.disabled:hover {
    cursor: not-allowed;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const PhoneNumberDisplay = styled(Body2)`
  font-size: ${fontSizes.s12};
`;

export const StyledAvatar = styled(Avatar)`
  flex-shrink: 0;
`;

export const StyledInfoBanner = styled(InfoBanner)`
  margin-bottom: ${spacing.double};
`;

export const ErrorTextWrapper = styled.div`
  display: flex;

  & > * {
    margin-right: ${spacing.quarter};
  }
`;
